'use strict';

var React = require('react');
var ClassNames = require('classnames');

var InlineInfoButton = React.createClass({
    propTypes: {
        helpText: React.PropTypes.string,
        isHidden: React.PropTypes.bool.isRequired,
        toggleShowHideHelpText: React.PropTypes.func.isRequired
    },
    getDefaultProps: function () {
        return {
            isHidden: true
        };
    },

    render: function () {
		if(!this.props.helpText) { 
			return false;
		}
        return (<div className={ClassNames({ hidden: !this.props.helpText }, 'inline-info-button')}>
                    <a className="icon-click" onClick={this.props.toggleShowHideHelpText } title={this.props.message}>
										<span className={ClassNames('inline-info-arrow', { hidden: this.props.isHidden })} />
										<i className={ClassNames('icon', { 'icon-info-circled': this.props.isHidden }, { 'icon-cancel-circled': !this.props.isHidden })} />
					</a>
        </div>);
    }
});

module.exports = InlineInfoButton;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/InlineInfoButton.jsx